import React from 'react';
import { components } from 'react-select-v3';
import { Icon } from '@ontruck/orc';

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon glyph="search" size="1.5rem" color={props.isFocused ? 'primary500' : 'grey700'} />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
